import { render, staticRenderFns } from "./TagDialog.vue?vue&type=template&id=480d0726&"
import script from "./TagDialog.vue?vue&type=script&lang=ts&"
export * from "./TagDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports